<section>
    <div class="columns height-full">
      <div class="column is-4 height-full p-0">
        <div class="form-part">
          <div class="is-flex is-justify-content-center is-fullWidth">
            <img src="./assets/images/logo-login.png" alt="logo-basf" width="200" height="250">
          </div>
          <form [formGroup]="loginForm" (ngSubmit)="onLogin()">
            @if (hasErrorLogin) {
              <div class="login-error" role="alert" aria-live="polite">
                <fa-icon [icon]="faTriangleExclamation" class="login-error__icon" aria-hidden="true"></fa-icon>
                <span>Credenciales incorrectas. Comprueba tu usuario y contraseña.</span>
              </div>
            }
            <div class="field">
              <label class="label" for="login-email">Usuario</label>
              <div class="control">
                <input
                  id="login-email"
                  class="input"
                  [class.is-danger]="hasErrorLogin"
                  type="text"
                  placeholder="Usuario"
                  formControlName="email"
                  [attr.aria-invalid]="hasErrorLogin ? 'true' : null"
                >
              </div>
            </div>
            <div class="field mt-4">
              <label class="label" for="login-password">Contraseña</label>
              <div class="control">
                <input
                  id="login-password"
                  class="input"
                  [class.is-danger]="hasErrorLogin"
                  type="password"
                  placeholder="Contraseña"
                  formControlName="password"
                  [attr.aria-invalid]="hasErrorLogin ? 'true' : null"
                >
              </div>
            </div>
            <button class="button is-primary is-fullwidth mt-5" type="submit" [disabled]="!loginForm.valid || isLoading">
              @if (!isLoading) {
                <span>Acceder</span>
              } @else {
                <fa-icon [icon]="faSpinner" [pulse]="true"></fa-icon>
              }
            </button>
          </form>
        </div>
      </div>
      <div class="column is-8 image-login height-full"></div>
    </div>
  </section>
